var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelDigitalAdFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#5CA539",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.78 6.214a1 1 0 0 1 1.006 1.007v9.558a1 1 0 0 1-1.007 1.007h-1.784l-1.348-3.334 1.44-.062c.506-.022.661-.318.37-.678l-.07-.078-4.634-4.794c-.384-.396-.69-.269-.69.28l-.005 6.667c0 .551.335.697.75.332l1.072-.946 1.055 2.612H7.221a1 1 0 0 1-1.007-1.006V7.221a1 1 0 0 1 1.007-1.007z"
}))));
export default SvgGemChannelDigitalAdFilled;